import { Directive, HostListener, Input, inject } from '@angular/core';
import { MixpanelService } from 'taxtank-core/common';

@Directive({
  selector: '[appTrack]',
  standalone: false
})
export class TrackDirective {
  private mpService = inject(MixpanelService);

  @Input('appTrack') event: string;
  @Input() appTrackProps: { [key: string]: any } = {};

  

  @HostListener('click')
  onClick(): void {
    this.mpService.track(this.event, this.appTrackProps);
  }
}
